var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5119 9.53415L10.6233 17.4228C8.8293 19.2168 5.9207 19.2168 4.12673 17.4228C2.33276 15.6288 2.33276 12.7202 4.12673 10.9263L12.0154 3.03761C13.2114 1.84163 15.1504 1.84163 16.3464 3.03761C17.5424 4.23359 17.5424 6.17266 16.3464 7.36864L8.76712 14.9479C8.16913 15.5459 7.19959 15.5459 6.6016 14.9479C6.00361 14.3499 6.00361 13.3804 6.6016 12.7824L13.2528 6.1312",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.6a9b28fd986a11e5c6c648d026b7034e.svg";
export { ForwardRef as ReactComponent };